import {
  FETCH_ORDER_PENDING,
  FETCH_ORDER_REJECTED,
  FETCH_ORDER_FULFILLED,
  RESET_ORDER
} from "../constants/orderSearch";

const initialState = {
  pending: false,
  order: {},
  error: {},
  count: 0
};

export const orderSearch = (state = initialState, action) => {
  switch (action.type) {
    case RESET_ORDER:
      return { order: {}, pending: false, error: [] };

    case FETCH_ORDER_PENDING:
      return { ...state, order: {}, pending: true, error: [] };

    case FETCH_ORDER_REJECTED:
      return { ...state, pending: false, error: action.error.response.data };

    case FETCH_ORDER_FULFILLED:
      return {
        ...state,
        order: action.response,
        pending: false,
        error: []
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/orderSearch.js